import { useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { id: "work", label: "Work", testid: "nav-link-work" },
  { id: "services", label: "Services", testid: "nav-link-services" },
  { id: "about", label: "Studio", testid: "nav-link-about" },
  { id: "contact", label: "Contact", testid: "nav-contact-cta" },
];

export const Navbar = ({ onShowreel }) => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav data-testid="nav-container" className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#070709]/70 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 hover:opacity-80 transition-opacity">
          <img src="/kth-logo.png" alt="KTH Studios — Kingdom of Theatrical Horizon" className="h-12 w-auto" />
        </button>
        <div className="hidden md:flex items-center gap-8">
          <button data-testid="nav-link-showreel" onClick={onShowreel}
            className="font-mono2 text-xs tracking-[0.25em] text-zinc-400 hover:text-amber-500 transition-colors">SHOWREEL</button>
          {LINKS.map((l) => (
            <button key={l.id} data-testid={l.testid} onClick={() => go(l.id)}
              className="font-mono2 text-xs tracking-[0.25em] text-zinc-400 hover:text-amber-500 transition-colors">
              {l.label.toUpperCase()}
            </button>
          ))}
          <button data-testid="nav-request-pitch-btn" onClick={() => go("contact")}
            className="font-mono2 text-xs tracking-[0.2em] bg-amber-500 text-[#070709] px-5 py-2.5 font-semibold hover:bg-amber-400 transition-colors">
            REQUEST PITCH
          </button>
        </div>
        <button data-testid="nav-mobile-menu-btn" className="md:hidden text-zinc-200" onClick={() => setOpen(!open)}>
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden border-t border-white/10 bg-[#0E0E12] px-6 py-4 flex flex-col gap-4">
          <button onClick={() => { setOpen(false); onShowreel(); }} className="text-left font-mono2 text-sm tracking-widest text-zinc-300">SHOWREEL</button>
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} className="text-left font-mono2 text-sm tracking-widest text-zinc-300">
              {l.label.toUpperCase()}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};
